import SidebarRouterButton from '@/hoc/SidebarMenu/bones/SidebarRouterButton'
import type { MenuLinkView } from '../types'
import { StyledMenuEntryLink } from '../styled-components'

interface MenuLinkProps {
  link: MenuLinkView
  expanded: boolean
  fill: boolean
}

const MenuLink = ({ link, expanded, fill }: MenuLinkProps) => (
  <StyledMenuEntryLink
    to={link.to}
    id={link.id}
    aria-label={link.label}
    data-menu-slot
    aria-current={link.selected ? 'page' : undefined}
    $fill={fill}
    $expanded={expanded}
    onMouseEnter={link.onMouseEnter}
  >
    <SidebarRouterButton text={link.label} icon={link.icon} isSelected={link.selected} floating expanded={expanded} />
  </StyledMenuEntryLink>
)

export default MenuLink
